import { Quote, Heart } from "lucide-react";
import { Reveal, Overline } from "@/components/Reveal";

export default function Community({ content }) {
  const items = (content.community_items || [])
    .map((line) => {
      const [name, role, ...q] = line.split("|").map((s) => s.trim());
      return { name, role, quote: q.join(" | ") };
    })
    .filter((i) => i.name);

  return (
    <section id="community" data-testid="community-section" className="bg-white py-20 sm:py-28 lg:py-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal className="max-w-2xl mx-auto text-center flex flex-col items-center">
          <Overline>Community Love</Overline>
          <h2 className="mt-6 font-serif font-bold tracking-tight text-navy text-3xl sm:text-4xl lg:text-5xl leading-[1.1]" data-testid="community-title">
            What scholars say about us
          </h2>
        </Reveal>

        {items.length === 0 ? (
          <Reveal delay={0.15}>
            <div
              data-testid="community-placeholder"
              className="mt-14 max-w-2xl mx-auto border-2 border-dashed border-navy/15 rounded-3xl px-8 py-14 text-center bg-chalk/60"
            >
              <span className="inline-flex items-center justify-center h-14 w-14 rounded-full bg-cherry/10">
                <Heart className="h-6 w-6 text-cherry" fill="currentColor" />
              </span>
              <p className="mt-6 font-serif text-2xl sm:text-3xl font-semibold text-navy">
                Feedback from Batch 01 is on its way
              </p>
              <p className="mt-3 text-sm sm:text-base font-sans text-[#5B6B7C] leading-relaxed max-w-md mx-auto">
                Real words from real scholars will appear here right after the 21–22 October Mendeley masterclass. Be the first story we share.
              </p>
            </div>
          </Reveal>
        ) : (
          <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
            {items.map((item, i) => (
              <Reveal key={i} delay={0.1 + i * 0.1}>
                <figure
                  data-testid={`community-card-${i}`}
                  className="h-full bg-chalk border border-navy/10 rounded-2xl p-7 hover:border-cherry/30 hover:shadow-xl hover:-translate-y-1 transition-all duration-300"
                >
                  <Quote className="h-6 w-6 text-cherry" fill="currentColor" />
                  <blockquote className="mt-4 font-serif italic text-lg text-navy/90 leading-relaxed">
                    {item.quote}
                  </blockquote>
                  <figcaption className="mt-5 pt-4 border-t border-navy/10">
                    <p className="font-sans font-semibold text-navy text-sm">{item.name}</p>
                    {item.role && <p className="text-xs font-mono uppercase tracking-widest text-cherry mt-0.5">{item.role}</p>}
                  </figcaption>
                </figure>
              </Reveal>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
